module.exports = __webpack_public_path__ + "assets/img/20240405.94ebc599.png";